const isAString = (password) =>
  typeof password === "string" || password instanceof String
    ? null
    : "Password should be a string";
const isAtleast = (minLength) => (password) =>
  password.length >= minLength
    ? null
    : `Password should be at least ${minLength} characters long.`;
const containsAlphabetic = (password) =>
  password.split("").some((c) => c.toLowerCase() !== c.toUpperCase())
    ? null
    : "Password should contain at least one alphabetic character.";
const containsNumeric = (password) =>
  password.split("").some((c) => Number.parseFloat(c) === +c)
    ? null
    : "Password should contain at least one numeric character.";
const containsSpecial = (password) =>
  password.split("").some((c) => "#$^+=!*()@%&_-".includes(c))
    ? null
    : "Password should contain at least one special character.";

const policies = [
  isAString,
  isAtleast(8),
  containsAlphabetic,
  containsNumeric,
  containsSpecial,
];

export const validatePassword = (password) => {
  const errors = policies
    .map((policy) => policy(password))
    .filter((e) => e !== null);
  const isValid = errors.length === 0;

  return { errors, isValid };
};
